<template>
    <label class="block font-medium text-sm text-gray-700">
        <span v-if="value"> {{ value }} <span v-if="required !== undefined" class="text-red-700" title="Povinná položka">*</span> </span>
        <span v-else> <slot></slot> <span v-if="required !== undefined" class="text-red-700" title="Povinná položka">*</span> </span>
    </label>
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: ['value', 'required']
    })
</script>
